import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigationItems = [
    { path: '/', label: 'Kāinga' },
    { path: '/kaupapa-history', label: 'Te Tīmatanga' },
    { path: '/tangata-whenua-rights', label: 'Tangata Whenua Rights' },
    { path: '/tinorangatiratanga', label: 'Tino Rangatiratanga' },
    { path: '/he-whakaputanga', label: 'He Whakaputanga' },
    { path: '/whenau-housing', label: 'Whenua & Housing' },
    { path: '/whenau-gardening', label: 'Whenua & Gardening' },
    { path: '/business-plan', label: 'Business Plan' },
    { path: '/follow', label: 'Follow' },
    { path: '/whakapapa', label: 'Whakapapa' },
    { path: '/store', label: 'Store' },
  ];

  return (
    <header className="bg-white shadow-md sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          <Link to="/" className="hover:opacity-80 transition-opacity">
            <Logo />
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden lg:flex space-x-6">
            {navigationItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="text-gray-700 hover:text-ocean-teal transition-colors duration-200 font-medium"
              >
                {item.label}
              </Link>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-md hover:bg-gray-100 transition-colors"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle navigation menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden pb-4 border-t border-gray-200 pt-4">
            {navigationItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className="block py-3 text-gray-700 hover:text-ocean-teal hover:bg-gray-50 px-2 rounded transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </Link>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
